import {useState,useEffect} from 'react';
import youtube from '../apis/youtube';
import unsplash from '../apis/unsplash';

const useVideos = (defaultSearchTerm) => {
    const [videos,setVideos] = useState([]);
    const [images,setImage] = useState([]);
    

    useEffect(()=>{     //whenever we use outside variable in our hook, react wants to know (means we list that variable inside second argument array...eg:defaultSearchTerm)
        search(defaultSearchTerm);
      },[defaultSearchTerm]);

      const search = async term => {
        const response = await youtube.get('/search', {
          params: {
            q: term
          }
        });
    
        setVideos(response.data.items);


        //for searching images
        const response1 = await unsplash.get('/search/photos',{
          params:{ query:term } 
        });
      
        setImage(response1.data.results);
      };


      return [videos,search,images,defaultSearchTerm];        //Convention: useState returns an array that has a piece of state and a setter inside it

      //or we could return an object that has properties of videos and onTermSubmit
};

export default useVideos;